// Status is derived, not stored. The only manual input is `done` (a checkbox in the
// editor) — everything else follows from date vs. today:
//   no date            -> idea
//   done               -> presented (regardless of date)
//   future date        -> planned
//   past date, !done   -> flagged (needs a decision: mark done, push the date, or delete)
// Legacy stories saved before `done` existed had a manual status field — `status:
// 'presented'` is treated as done so old data still resolves correctly.
const todayStr = () => new Date().toISOString().slice(0, 10)

export const STATUS_LABELS = { idea: 'Idé', planned: 'Planerad', flagged: 'Att bekräfta', presented: 'Genomförd' }

const isDone = (storyData) => {
  if (typeof storyData.done === 'boolean') return storyData.done
  return storyData.status === 'presented' // legacy fallback
}

export const resolveStatus = (storyData) => {
  const d = storyData || {}
  if (!d.date) return 'idea'
  if (isDone(d)) return 'presented'
  return d.date < todayStr() ? 'flagged' : 'planned'
}

export const statusOf = (storyData) => {
  const cls = resolveStatus(storyData)
  return { cls, label: STATUS_LABELS[cls] }
}
